import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';

class PluginTerminate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      costCheckboxChecked: false,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      show,
      pluginTerminateFormStatus,
      close,
      doNotify,
    } = this.props;

    if (!prevProps.show && show) {
      this.setState({ costCheckboxChecked: false });
    }

    // if the plugin is terminated, inform the user and close the modal
    if (
      prevProps.pluginTerminateFormStatus.pending &&
      !pluginTerminateFormStatus.pending &&
      !pluginTerminateFormStatus.hasError
    ) {
      doNotify(1, messages.plugin_terminated);
      close();
    }
  };

  onSubmit = () => {
    this.props.submitPluginTerminate(this.props.whiteLabelProject.id, this.props.plugin.id, {});
  };

  close = () => {
    // if the form is pending (sepa or plugin activation), do not close the modal
    if (!this.props.pluginTerminateFormStatus.pending) {
      this.props.close();
    }
  };

  renderContent = () => {
    const {
      intl: { messages },
      plugin,
    } = this.props;
    const { costCheckboxChecked } = this.state;

    const pending = this.props.pluginTerminateFormStatus.pending;

    const costCheckbox = (
      <div class="checkbox check-success">
        <input
          disabled={pending}
          id={'costCheckbox'}
          name="costCheckbox"
          type="checkbox"
          value={'true'}
          checked={this.state.costCheckboxChecked}
          onChange={e => this.setState({ costCheckboxChecked: e.target.checked })}
        />
        <label for={'costCheckbox'}>{messages.i_understand_the_running_cost_when_terminating_plugin}</label>
      </div>
    );

    return plugin ? (
      <div>
        <p>{messages.are_you_sure_you_want_to_terminate_plugin}</p>
        <p className="hint-text small"></p>

        {costCheckbox}

        <Button block disabled={!costCheckboxChecked || pending} bsStyle="danger" onClick={this.onSubmit}>
          {pending && <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />}

          {messages.terminate_plugin}
        </Button>
      </div>
    ) : null;
  };

  render() {
    const {
      intl: { messages },
      show,
      plugin,
      useModal,
    } = this.props;

    if (!useModal) {
      return (
        <div>
          <h4>{messages.terminate_plugin}</h4>
          {this.renderContent()}
        </div>
      );
    }

    return plugin ? (
      <Modal show={show} onHide={this.close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.terminate_plugin} • {plugin.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderContent()}</Modal.Body>
      </Modal>
    ) : null;
  }
}

PluginTerminate.defaultProps = {
  useModal: true,
  close: () => {},
};

const mapStateToProps = state => {
  return {
    pluginTerminateFormStatus: state.formStatus.pluginTerminate,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    submitPluginTerminate: (whiteLabelId, pluginId, data) => {
      formStatusDispatchHelper(
        'pluginTerminate',
        '/api/whitelabels/' + whiteLabelId + '/plugins/' + pluginId + '/terminate.json',
        data,
        'post',
        dispatch
      );
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PluginTerminate)
  )
);
